import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './contabilidad/guards/auth.guard';

export const AppRoutes: Routes = [ {
        path: 'contabilidad',
        component: AdminLayoutComponent,
        children: [{
            path: '',
            loadChildren: './dashboard/dashboard.module#DashboardModule',
            canActivate: [AuthGuard]
        }, {
            path: '',
            loadChildren: './contabilidad/contabilidad.module#ContabilidadModule'
        }
      ]
        }, {
            path: 'pages',
            component: AuthLayoutComponent,
            children: [{
                path: '',
                loadChildren: './pages/pages.module#PagesModule'
            }]
        },
  {
    path: '**',
    redirectTo: 'contabilidad/dashboard'
  }
];
